if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        document
          .querySelectorAll('#sizeChartModal[data-quickadd-mounted="true"], #sizepop[data-quickadd-mounted="true"]')
          .forEach((node) => node.remove());

        if (preventFocus) this.openedBy = null;
        document.body.classList.remove('no-scroll');
        this.classList.remove(
          'quick-add-modal--media-first',
          'quick-add-modal--media-first_3',
          'quick-add-modal--media-slider_1_2',
          'quick-add-modal--media-slider_3_images'
        );
        this.modalContent.classList.remove(
          'swiper-init-done',
          'swiper-first',
          'swiper-first_3',
          'swiper-slider_1_2',
          'swiper-slider_3_images'
        );
        super.hide();
      }

      show(opener) {
        this.lastQuickAddOpener = opener;
        const productGrid = document.getElementById('product-grid');
        const mediaSetting = productGrid ? productGrid.dataset.quickAddMedia : 'none';

        if (mediaSetting !== 'none') {
          this.classList.add(`quick-add-modal--media-${mediaSetting}`);
          const card = opener.closest('.card-wrapper') || opener.closest('.card');
          if (card) {
            card.querySelectorAll('img').forEach((img) => {
              if (img.src) new Image().src = img.src;
            });
          }
        }

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

            if (mediaSetting !== 'none') {
              const mediaGallery =
                responseHTML.querySelector('media-gallery') || responseHTML.querySelector('[id^="MediaGallery-"]');
              if (mediaGallery) {
                const images = mediaGallery.querySelectorAll('img');
                let limit = 3;

                if (mediaSetting === 'first') {
                  limit = 1;
                }

                if (mediaSetting === 'slider_3_images') {
                  limit = 10;
                }
                let count = 0;
                const seen = new Set();
                for (const img of images) {
                  const src = img.getAttribute('src') || img.getAttribute('data-src');
                  if (src && !seen.has(src)) {
                    seen.add(src);
                    new Image().src = src;
                    count++;
                    if (count >= limit) break;
                  }
                }
              }
            }

            const productId = opener.getAttribute('data-product-id');
            let productElement = null;
            if (productId) {
              productElement = responseHTML.querySelector(`product-info[data-product-id="${productId}"]`);
            }
            if (!productElement) {
              productElement =
                responseHTML.querySelector('#MainContent product-info') || responseHTML.querySelector('product-info');
            }
            if (!productElement) {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener.querySelector('.loading__spinner').classList.add('hidden');
              console.error('Quick add: product-info not found in fetched product page.');
              return;
            }
            const sizeChartModalElement = responseHTML.querySelector('#sizeChartModal, #sizepop');

            this.preprocessHTML(productElement, responseHTML);
            this.removeExecutableScripts(productElement);
            if (sizeChartModalElement) this.removeExecutableScripts(sizeChartModalElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            if (this.classList.contains('quick-add-modal--standard-new') && sizeChartModalElement) {
              this.modalContent.insertAdjacentHTML('beforeend', sizeChartModalElement.outerHTML);
              const injectedSizeChartModal = this.modalContent.querySelector('#sizeChartModal, #sizepop');
              if (injectedSizeChartModal) this.ensureSizeChartModalStyles(injectedSizeChartModal);
            }
            this.postProcessNewQuickAddContent();
            this.initializeQuickAddSwiper();
            this.initializeEmbeddedSizeChart();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            const text = window.view_more_text;
            const button = this.modalContent.querySelector('.view-more-add-to-cart');

            if (text && button) {
              button.style.removeProperty('display');

              const textNode = button.querySelector('.text');

              if (textNode) {
                textNode.textContent = text;
              }
            }


            super.show(opener);
            this.handleRequiredSizeSelection();
            document.body.classList.add('no-scroll');
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleRequiredSizeSelection() {
        if (!this.hasAttribute('data-require-size-selection')) return;

        const root = this.modalContent;
        if (!root) return;

        const fieldsets = root.querySelectorAll('fieldset');
        if (!fieldsets.length) return;

        fieldsets.forEach((fieldset) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.checked = false;
          });
        });

        const form = root.querySelector('form');
        const button = root.querySelector('[name="add"]');
        if (!form || !button) return;

        let error = root.querySelector('.quick-add-error');
        if (!error) {
          error = document.createElement('div');
          error.className = 'quick-add-error';
          error.style.color = 'red';
          error.style.marginTop = '8px';
          error.style.display = 'none';

          const variantsWrap = fieldsets[fieldsets.length - 1];
          variantsWrap.insertAdjacentElement('afterend', error);
        }

        const errorText = this.getAttribute('data-size-error-text') || 'Please select a size';

        button.addEventListener('click', (e) => {
          const selected = root.querySelector('input[type="radio"]:checked');

          if (!selected) {
            e.preventDefault();
            e.stopPropagation();

            error.textContent = errorText;
            error.style.display = 'block';
            return;
          }

          error.style.display = 'none';
        });

        root.addEventListener('change', () => {
          error.style.display = 'none';
        });
      }

      preprocessHTML(productElement, responseHTML) {
        if (productElement.classList.contains('preprocessed')) return;
        productElement.classList.add('preprocessed');

        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });

        this.preventDuplicatedIDs(productElement);
        this.addFeaturedImageForNewQuickAdd(productElement, responseHTML);
        this.removeDOMElements(productElement);
        this.removeElementsForNewQuickAdd(productElement);
        if (this.classList.contains('quick-add-modal--hide-rating')) {
          this.removeRatingFromQuickAddProduct(productElement);
        } else {
          this.applyJudgeMeFallbackStars(productElement);
          this.moveRatingNearPriceForNewQuickAdd(productElement);
          this.normalizeReviewBadgeTextForNewQuickAdd(productElement);
        }
        this.stripCurrencyCodeForNewQuickAdd(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      removeExecutableScripts(rootElement) {
        if (!rootElement) return;

        rootElement.querySelectorAll('script').forEach((scriptEl) => {
          const type = (scriptEl.getAttribute('type') || '').toLowerCase();
          const isJsonScript =
            type === 'application/json' || type === 'application/ld+json' || type === 'application/vnd.api+json';

          if (!isJsonScript) scriptEl.remove();
        });
      }

      createQuickAddImageNode(sourceImage) {
        const image = sourceImage.cloneNode(true);
        const src =
          image.getAttribute('src') ||
          image.getAttribute('data-src') ||
          image.getAttribute('data-original-src') ||
          sourceImage.getAttribute('src') ||
          sourceImage.getAttribute('data-src') ||
          sourceImage.getAttribute('data-original-src');

        if (src) image.setAttribute('src', src);

        const srcset =
          image.getAttribute('srcset') ||
          image.getAttribute('data-srcset') ||
          sourceImage.getAttribute('srcset') ||
          sourceImage.getAttribute('data-srcset');

        if (srcset) image.setAttribute('srcset', srcset);

        image.removeAttribute('loading');
        image.classList.remove('lazyload', 'lazyautosizes', 'lazyloaded');

        return image;
      }

      getFallbackImagesFromOpenerCard() {
        const opener = this.lastQuickAddOpener;
        if (!opener) return [];

        const card = opener.closest('.card-wrapper') || opener.closest('.card');
        if (!card) return [];

        const images = [];
        const seen = new Set();

        card.querySelectorAll('img').forEach((img) => {
          const src = img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc;
          if (!src || seen.has(src)) return;
          seen.add(src);
          images.push(img);
        });

        return images;
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (!modalDialog) return;

        modalDialog.forEach((modal) => {
          if (
            this.classList.contains('quick-add-modal--standard-new') &&
            modal.classList.contains('product-popup-modal')
          ) {
            return;
          }
          modal.remove();
        });
      }

      removeRatingFromQuickAddProduct(productElement) {
        if (!this.classList.contains('quick-add-modal--hide-rating')) return;
        productElement.querySelectorAll('.rating-wrapper').forEach((node) => node.remove());
        productElement.querySelectorAll('.jdgm-widget.jdgm-preview-badge').forEach((node) => node.remove());
        productElement.querySelectorAll('.shopify-app-block').forEach((node) => node.remove());
        const priceRoot = productElement.querySelector('[id^="price-"]');
        if (priceRoot) {
          priceRoot.querySelectorAll('.quick-add-rating-app, .quick-add-rating-clone').forEach((node) => node.remove());
        }
      }

      removeElementsForNewQuickAdd(productElement) {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;

        const selectorsToRemove = [
          '.product__media-wrapper',
          '.product__media-gallery',
          '.product__media-list',
          '.icon-with-text',
          '.product__inventory',
          '.shoppay',
          '.shopify-payment-terms',
          '[data-shopify="payment-terms"]',
          '[data-shopify-installments]',
          '.shopify-payment-button',
          '.viewicon',
          '.product__media-icon',
          '.icon-eye',
          '.product__view-details',
        ];

        selectorsToRemove.forEach((selector) => {
          productElement.querySelectorAll(selector).forEach((node) => node.remove());
        });
      }

      moveRatingNearPriceForNewQuickAdd(productElement) {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;

        const priceElement = productElement.querySelector('[id^="price-"]');
        if (!priceElement) return;

        const existingMountedRating = productElement.querySelector(
          '.quick-add-rating-app, .quick-add-rating-clone'
        );

        // prevent duplicates when rating is before title
        if (
          window.rating_before_product_title &&
          productElement.querySelector('.quick-add-rating-app, .quick-add-rating-clone')
        ) {
          return;
        }

        const ratingElement =
          productElement.querySelector('.rating-wrapper') ||
          productElement.querySelector('.jdgm-widget.jdgm-preview-badge') ||
          productElement.querySelector('.shopify-app-block .jdgm-prev-badge') ||
          productElement.querySelector('.shopify-app-block .custom-fivestar');

        if (!ratingElement) return;

        const sourceAppBlock = ratingElement.closest('.shopify-app-block');

        if (sourceAppBlock) {
          const ratingWrap = document.createElement('div');
          ratingWrap.className = 'quick-add-rating-app';

          const fallback = sourceAppBlock.querySelector('.custom-fivestar');
          const jdgmBadge = sourceAppBlock.querySelector('.jdgm-prev-badge');

          if (fallback) {
            ratingWrap.appendChild(fallback.cloneNode(true));
          }

          if (jdgmBadge) {
            ratingWrap.appendChild(jdgmBadge.cloneNode(true));
          }

          if (ratingWrap.childElementCount > 0) {
            if (existingMountedRating) {
              existingMountedRating.remove();
            }

            if (window.rating_before_product_title) {
              const title = productElement.querySelector('.product__title');

              if (title) {
                title.parentNode.insertBefore(ratingWrap, title);
                return;
              }
            }

            priceElement.appendChild(ratingWrap);
          }

          return;
        }

        const ratingClone = ratingElement.cloneNode(true);
        ratingClone.classList.add('quick-add-rating-clone');

        if (existingMountedRating) {
          existingMountedRating.remove();
        }

        if (window.rating_before_product_title) {
          const title = productElement.querySelector('.product__title');

          if (title) {
            title.parentNode.insertBefore(ratingClone, title);
            return;
          }
        }

        priceElement.appendChild(ratingClone);
      }

      stripCurrencyCodeForNewQuickAdd(productElement) {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;

        const priceRoot = productElement.querySelector('[id^="price-"]');
        if (!priceRoot) return;

        const sanitize = () => {
          priceRoot.querySelectorAll('.price-item').forEach((node) => {
            if (!node || !node.textContent) return;
            const currentText = node.textContent;
            const nextText = currentText.replace(/\s*[A-Z]{3}\b/g, '').trim();
            if (nextText !== currentText) node.textContent = nextText;
          });
        };

        sanitize();
      }

      normalizeReviewBadgeTextForNewQuickAdd(productElement) {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;

        const priceRoot = productElement.querySelector('[id^="price-"]');
        if (!priceRoot) return;

        const normalize = () => {
          priceRoot.querySelectorAll('.jdgm-prev-badge__text').forEach((node) => {
            const raw = (node.textContent || '').trim();
            const countMatch = raw.match(/\d+/);
            if (!countMatch) return;
            const count = countMatch[0];
            const isMobile = window.matchMedia('(max-width: 749px)').matches;
            const nextText = isMobile ? `(${count})` : `(${count} Reviews)`;
            if (raw !== nextText) node.textContent = nextText;
          });
        };

        normalize();
      }

      applyJudgeMeFallbackStars(productElement) {
        const fallbackHTML = `
          <span class="jdgm-prev-badge__stars custom-fivestar" data-score="5" tabindex="0" aria-label="5 stars" role="button">
            <span class="jdgm-star jdgm--on"></span>
            <span class="jdgm-star jdgm--on"></span>
            <span class="jdgm-star jdgm--on"></span>
            <span class="jdgm-star jdgm--on"></span>
            <span class="jdgm-star jdgm--on"></span>
          </span>
        `;

        productElement.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
          const stars = badge.querySelector('.jdgm-prev-badge__stars');
          const hasFallback = badge.parentElement?.querySelector('.custom-fivestar');
          const isZeroScore = stars?.getAttribute('data-score') === '0.00' || stars?.getAttribute('data-score') === '0';

          if (isZeroScore && !hasFallback) {
            badge.parentElement?.insertAdjacentHTML('beforebegin', fallbackHTML);
          }
        });
      }

      /** Equal-width pill row: set column count for CSS grid (fieldset display:flex is unreliable across browsers). */
      setQuickAddPillGridColumns(productInfoRoot) {
        productInfoRoot.querySelectorAll('fieldset.product-form__input--pill').forEach((fieldset) => {
          const count = fieldset.querySelectorAll('input[type="radio"]').length;
          if (count < 1) return;

          fieldset.style.setProperty('--quick-add-pill-count', String(count));

          let columns = count;
          if (count >= 6 && count <= 8) {
            columns = 4;
          } else if (count >= 9) {
            columns = 5;
          }

          fieldset.style.setProperty('--quick-add-pill-columns', String(columns));
        });
      }

      postProcessNewQuickAddContent() {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;

        const mountedProductElement = this.modalContent.querySelector('product-info');
        if (!mountedProductElement) return;

        const run = () => {
          this.setQuickAddPillGridColumns(mountedProductElement);
          if (this.classList.contains('quick-add-modal--hide-rating')) {
            this.removeRatingFromQuickAddProduct(mountedProductElement);
          } else {
            this.applyJudgeMeFallbackStars(mountedProductElement);
            this.moveRatingNearPriceForNewQuickAdd(mountedProductElement);
            this.normalizeReviewBadgeTextForNewQuickAdd(mountedProductElement);
          }
          this.stripCurrencyCodeForNewQuickAdd(mountedProductElement);
        };

        run();
        requestAnimationFrame(run);
        setTimeout(run, 80);
        setTimeout(run, 220);

        if (mountedProductElement.dataset.quickAddEnhancerBound === 'true') return;
        mountedProductElement.addEventListener('change', () => {
          run();
          requestAnimationFrame(run);
          setTimeout(run, 80);
          setTimeout(run, 220);
        });
        mountedProductElement.dataset.quickAddEnhancerBound = 'true';
      }

      initializeQuickAddSwiper() {
        const swiper = this.modalContent.querySelector('.quick-add-swiper');

        if (!swiper) return;

        const productGrid = document.getElementById('product-grid');
        const mediaSetting = productGrid ? productGrid.dataset.quickAddMedia : 'none';

        this.modalContent.classList.add(`swiper-${mediaSetting}`);

        if (swiper.swiper) {
          swiper.swiper.destroy(true, true);
        }

        let slidesPerView = 1.42;
        let spaceBetween = 12;

        const isShortViewport = window.matchMedia('(max-height: 740px)').matches;
        if (mediaSetting === 'slider_1_2' && isShortViewport) {
          slidesPerView = 1.62;
        }

        if (mediaSetting === 'slider_3_images') {
          slidesPerView = 3;
          spaceBetween = 7;
        }

        new Swiper(swiper, {
          slidesPerView,
          spaceBetween,
          watchOverflow: true,

          navigation: {
            nextEl: swiper.querySelector('.swiper-button-next'),
            prevEl: swiper.querySelector('.swiper-button-prev'),
          },

          pagination: {
            el: swiper.querySelector('.swiper-pagination'),
            clickable: true,
          }
        });

        this.modalContent.classList.add('swiper-init-done');
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      addFeaturedImageForNewQuickAdd(productElement, responseHTML) {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;

        // Try to find the image in the current productElement first (in case of re-render)
        if (productElement.querySelector('.quick-add-modal__media')) return;

        const productGrid = document.getElementById('product-grid');
        const mediaSetting = productGrid ? productGrid.dataset.quickAddMedia : 'none';

        if (mediaSetting === 'none') return;

        const mediaSourceRoot =
          productElement.querySelector('media-gallery, [id^="MediaGallery-"], .product__media-wrapper, .product__media-gallery') ||
          responseHTML?.querySelector('media-gallery, [id^="MediaGallery-"], .product__media-wrapper, .product__media-gallery');
        let images = [];
        if (mediaSourceRoot) {
          // Get all unique images from the most reliable source available
          const mediaList = mediaSourceRoot.querySelector('.product__media-list');
          images = Array.from(mediaList ? mediaList.querySelectorAll('img') : mediaSourceRoot.querySelectorAll('img'));
        }

        if (!images.length) {
          images = this.getFallbackImagesFromOpenerCard();
        }

        if (!images.length) return;

        // Wrap existing content in a right-column div for desktop 2-column layout
        const infoWrapper = document.createElement('div');
        infoWrapper.className = 'product__info-wrapper';
        while (productElement.firstChild) {
          infoWrapper.appendChild(productElement.firstChild);
        }
        productElement.appendChild(infoWrapper);

        // Prepend the image (left column)
        const imageWrap = document.createElement('div');
        imageWrap.className = 'quick-add-modal__media';

        if (mediaSetting === 'first') {
          imageWrap.appendChild(this.createQuickAddImageNode(images[0]));
        } else if (mediaSetting === 'first_3') {
          // Use a Set to avoid duplicates if same image is repeated in media-gallery
          const seenSrcs = new Set();
          let count = 0;
          for (const img of images) {
            const src = img.getAttribute('src') || img.getAttribute('data-src');
            if (src && !seenSrcs.has(src)) {
              seenSrcs.add(src);
              imageWrap.appendChild(this.createQuickAddImageNode(img));
              count++;
              if (count >= 3) break;
            }
          }
          imageWrap.classList.add('quick-add-modal__media--multiple');
        } else if (mediaSetting === 'slider_1_2' || mediaSetting === 'slider_3_images') {
          imageWrap.classList.add('quick-add-modal__media--slider');

          if (mediaSetting === 'slider_3_images') {
            imageWrap.classList.add('quick-add-modal__media--slider-3');
          }

          const swiperEl = document.createElement('div');
          swiperEl.className = 'swiper quick-add-swiper';

          const swiperWrapper = document.createElement('div');
          swiperWrapper.className = 'swiper-wrapper';

          const seenSrcs = new Set();

          for (const img of images) {
            const src = img.getAttribute('src') || img.getAttribute('data-src');

            if (!src || seenSrcs.has(src)) continue;

            seenSrcs.add(src);

            const slide = document.createElement('div');
            slide.className = 'swiper-slide';

            const clonedImage = this.createQuickAddImageNode(img);

            slide.appendChild(clonedImage);
            swiperWrapper.appendChild(slide);
          }

          swiperEl.appendChild(swiperWrapper);

          // navigation
          const next = document.createElement('div');
          next.className = 'swiper-button-next';

          const prev = document.createElement('div');
          prev.className = 'swiper-button-prev';

          swiperEl.appendChild(next);
          swiperEl.appendChild(prev);

          // pagination
          const pagination = document.createElement('div');
          pagination.className = 'swiper-pagination';

          swiperEl.appendChild(pagination);

          imageWrap.appendChild(swiperEl);
        }

        productElement.prepend(imageWrap);
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      initializeEmbeddedSizeChart() {
        if (!this.classList.contains('quick-add-modal--standard-new')) return;
        if (!this.modalContent || this.modalContent.dataset.sizeChartBound === 'true') return;

        this.modalContent.addEventListener('click', (event) => {
          const openTrigger = event.target.closest('.sizeChart');
          if (openTrigger) {
            event.preventDefault();
            const chartModal =
              this.modalContent.querySelector('#sizeChartModal, #sizepop') ||
              document.querySelector('#sizeChartModal[data-quickadd-mounted="true"], #sizepop[data-quickadd-mounted="true"]');
            if (chartModal) {
              const readyModal = this.mountSizeChartModal(chartModal);
              readyModal.style.display = 'block';
            }
            return;
          }

          const closeTrigger = event.target.closest('.close-modal, .closeSize');
          if (closeTrigger) {
            event.preventDefault();
            const chartModal =
              this.modalContent.querySelector('#sizeChartModal, #sizepop') ||
              document.querySelector('#sizeChartModal[data-quickadd-mounted="true"], #sizepop[data-quickadd-mounted="true"]');
            if (chartModal) chartModal.style.display = 'none';
            return;
          }

          const chartModal =
            this.modalContent.querySelector('#sizeChartModal, #sizepop') ||
            document.querySelector('#sizeChartModal[data-quickadd-mounted="true"], #sizepop[data-quickadd-mounted="true"]');
          if (chartModal && event.target === chartModal) {
            chartModal.style.display = 'none';
          }
        });

        this.modalContent.dataset.sizeChartBound = 'true';
      }

      mountSizeChartModal(chartModal) {
        const existingMounted = document.querySelector('#sizeChartModal[data-quickadd-mounted="true"], #sizepop[data-quickadd-mounted="true"]');
        if (existingMounted && existingMounted !== chartModal) existingMounted.remove();

        if (!chartModal.dataset.quickaddMounted) {
          this.ensureSizeChartModalStyles(chartModal);
          chartModal.dataset.quickaddMounted = 'true';
          document.body.appendChild(chartModal);
          this.bindSizeChartCloseHandlers(chartModal);
        }
        return chartModal;
      }

      bindSizeChartCloseHandlers(chartModal) {
        if (!chartModal || chartModal.dataset.quickaddCloseBound === 'true') return;

        chartModal.addEventListener('click', (event) => {
          if (event.target === chartModal || event.target.closest('.close-modal, .closeSize')) {
            event.preventDefault();
            chartModal.style.display = 'none';
          }
        });

        chartModal.dataset.quickaddCloseBound = 'true';
      }

      ensureSizeChartModalStyles(chartModal) {
        if (!chartModal) return;
        chartModal.classList.add('quickadd-sizechart-modal');
        chartModal.style.display = 'none';
      }
    }
  );
}
